import { supabase } from "./supabase";

/** Resposta padrão das RPCs do WMS: ok:false é regra de negócio (código errado etc.). */
export interface RespostaWms {
  ok: boolean;
  codigo_erro?: string;
  mensagem?: string;
  repetido?: boolean;
  [chave: string]: unknown;
}

const mensagens: Record<string, string> = {
  WM001: "Saldo insuficiente no local",
  WM002: "Reserva insuficiente",
  WM003: "Local bloqueado ou inativo",
  WM004: "Dados inválidos",
  WM005: "Ação repetida com dados diferentes",
  WM011: "Local não cadastrado",
  WM020: "Ação não permitida neste momento",
  WM403: "Seu usuário não tem permissão para esta ação",
};

export class ErroWms extends Error {
  constructor(message: string, public codigo?: string) {
    super(message);
  }
}

/** Chama uma RPC. Exceção do banco vira ErroWms; ok:false volta normal para a tela tratar. */
export async function rpc<T extends RespostaWms = RespostaWms>(nome: string, args: Record<string, unknown> = {}): Promise<T> {
  const { data, error } = await supabase.rpc(nome, args);
  if (error) {
    const codigo = error.code;
    const texto = error.message && !/^WM\d{3}$/.test(error.message) ? error.message : mensagens[codigo] ?? "Erro inesperado";
    throw new ErroWms(texto, codigo);
  }
  return data as T;
}

/** RPC que deve dar certo: ok:false também vira exceção. */
export async function rpcOk<T extends RespostaWms = RespostaWms>(nome: string, args: Record<string, unknown> = {}): Promise<T> {
  const r = await rpc<T>(nome, args);
  if (r && r.ok === false) throw new ErroWms(r.mensagem ?? "Operação recusada", r.codigo_erro);
  return r;
}

export const novaChave = () => crypto.randomUUID();

export function mensagemDeErro(e: unknown): string {
  if (e instanceof Error) return e.message;
  return String(e);
}
